import { callApi, HttpMethod } from "../../../utils/httpRequest";

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'hcfId' implicitly has an 'any' type.
const fetchHcfDetails = async (hcfId, field) => {
  if (!hcfId || !field) {
    return null;
  }

  const [res] = await callApi({
    method: HttpMethod.GET,
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    url: `${global.api}/facilityprofile/details`,
    query: {
      facilityIds: hcfId,
      projection: field,
    },
  });
  return res;
};

export { fetchHcfDetails };
